export default [
    {
        path: '/procurement/project/list/:filter?',
        name: 'procurement_project_list',
        component: () => import('@src/procurement/procurement-project/procurement-project-list'),
        meta: {
            title: 'Projekte',
            role: 'ROLE_LIST_PROCUREMENT_PROJECT',
        },
    },
    {
        path: '/procurement/project/create',
        name: 'procurement_project_create',
        component: () => import('@src/procurement/procurement-project/procurement-project.vue'),
        meta: {
            title: 'Projekt anlegen',
            role: 'ROLE_EDIT_PROCUREMENT_PROJECT',
        },
    },
    {
        path: '/procurement/project/edit/:id',
        name: 'procurement_project_edit',
        component: () => import('@src/procurement/procurement-project/procurement-project.vue'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Projekt bearbeiten',
            role: 'ROLE_EDIT_PROCUREMENT_PROJECT',
        },
    },

    {
        path: '/procurement/purchase-invoice/list/:filter?',
        name: 'procurement_purchase_invoice_list',
        component: () => import('@src/procurement/purchase-invoice/purchase-invoice-list'),
        meta: {
            title: 'Lieferantenrechnungen',
            role: 'ROLE_LIST_PURCHASE_INVOICE',
            favoriteRouteName: 'procurement_purchase_invoice_list',
        },
    },
    {
        path: '/procurement/purchase-invoice/edit/:id',
        name: 'procurement_purchase_invoice_edit',
        component: () => import('@src/procurement/purchase-invoice/purchase-invoice-edit'),
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Lieferantenrechnung bearbeiten',
            role: 'ROLE_EDIT_PURCHASE_INVOICE',
        },
    },
    {
        path: '/procurement/purchase-invoice/create',
        name: 'procurement_purchase_invoice_create',
        component: () => import('@src/procurement/purchase-invoice/purchase-invoice-edit'),
        meta: {
            title: 'Lieferantenrechnung anlegen',
            role: 'ROLE_EDIT_PURCHASE_INVOICE',
        },
    },
    {
        path: '/procurement/purchase-credit-note/list/:filter?',
        name: 'procurement_purchase_credit_note_list',
        component: () => import('@src/procurement/purchase-credit-note/purchase-credit-note-list'),
        meta: {
            title: 'Lieferantengutschriften',
            role: 'ROLE_LIST_PURCHASE_CREDIT_NOTE',
            favoriteRouteName: 'procurement_purchase_credit_note_list',
        },
    },
    {
        path: '/procurement/purchase-credit-note/edit/:id',
        name: 'procurement_purchase_credit_note_edit',
        component: () => import('@src/procurement/purchase-credit-note/purchase-credit-note-edit'),
        props(route) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Lieferantengutschrift bearbeiten',
            role: 'ROLE_EDIT_PURCHASE_CREDIT_NOTE',
        },
    },
    {
        path: '/procurement/purchase-credit-note/create',
        name: 'procurement_purchase_credit_note_create',
        component: () => import('@src/procurement/purchase-credit-note/purchase-credit-note-edit'),
        meta: {
            title: 'Lieferantengutschrift anlegen',
            role: 'ROLE_EDIT_PURCHASE_CREDIT_NOTE',
        },
    },
    {
        path: '/procurement/purchase-invoice/file-upload',
        name: 'procurement_purchase_invoice_file_upload',
        component: () => import('@src/procurement/purchase-invoice-file-upload/file-upload.vue'),
        meta: {
            title: 'Originalrechnungen einlesen',
            role: 'ROLE_EDIT_PURCHASE_INVOICE',
        },
    },
];
